const initialState = {
    collection: {},
    ids: [],
    total: null,
};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'APM_ISSUES_SUCCESS') {
        return {
            ...state,
            collection: action.payload.issues.reduce(
                (acc, { fields, id, key }) => ({
                    ...acc,
                    [key]: {
                        assignee: fields.assignee?.displayName,
                        components: fields.components,
                        created: fields.created,
                        description: fields.description,
                        id,
                        key,
                        labels: fields.labels,
                        priority: fields.priority?.name,
                        status: fields.status?.name,
                        summary: fields.summary,
                    },
                }),
                {}
            ),
            ids: action.payload.issues.map(item => item.key),
            total: action.payload.total,
        };
    }

    return state;
}

export default reducer;
